module.exports = __webpack_public_path__ + "assets/pdf/BN01-en-sulphate-aerosol.8c3987dd.pdf";